import { render, staticRenderFns } from "./splash.html?vue&type=template&id=0f4d5b97&scoped=true&"
import script from "./splash.vue?vue&type=script&lang=js&"
export * from "./splash.vue?vue&type=script&lang=js&"
import style0 from "./splash.vue?vue&type=style&index=0&id=0f4d5b97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4d5b97",
  null
  
)

export default component.exports